import { workflowsRepo } from '@/constants/providers';
import { ProcessKey } from '@/modules/Processes/queries';
import { TaskKey } from '@/modules/Tasks/queries';
import { ApiResponse } from '@/shared/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import { OrderWorkflow } from '../types';
import { WorkflowKey } from './keys';

export const useOrderWorkflow = () => {
  const queryClient = useQueryClient();
  return useMutation<ApiResponse<unknown>, unknown, OrderWorkflow>(
    (workflow) => workflowsRepo.orderWorkflow(workflow),
    {
      onError: () => {
        toast.error(t('error_order_workflow'));
      },
      onSettled: () => {
        queryClient.invalidateQueries(TaskKey.ALL);
        queryClient.invalidateQueries(WorkflowKey.ALL);
        queryClient.invalidateQueries(ProcessKey.ALL);
      },
    },
  );
};
